import axios from "./axiosInstance";

const LoginAPI = {
  postLoginDetails: (params) => axios.post(`/login`, params),
};

export default LoginAPI;
